module.exports = __webpack_public_path__ + "img/lp-logo.6ca09791.webp";